import axios from 'axios';
import { mapGetters } from 'vuex';
axios.defaults.serverIp = process.env.VUE_APP_SERVER_IP;
axios.defaults.baseURL = axios.defaults.serverIp + '/';
axios.defaults.admin = axios.defaults.serverIp + '/admin/';

const methods = {
  async admin_get(url, params) {
    if (this.$store.getters.userAccToken == null) {
      alert('로그인이 필요한 서비스입니다.');
      this.$_goTo({ name: 'login' });
    } else {
      let $_url = axios.defaults.baseURL + url;
      let $_res = '';
      $_res = axios({
        method: 'GET',
        url: $_url,
        params: params,
        headers: {
          Authorization: `Bearer ${this.$store.getters.userAccToken}`,
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            return res;
          } else {
            return false;
          }
        })
        .catch(err => {
          return err;
        });

      return $_res;
    }
  },
  async admin_post(url, params) {
    if (this.$store.getters.userAccToken == null) {
      alert('로그인이 필요한 서비스입니다.');
    } else {
      let $_url = axios.defaults.baseURL + url;
      let $_res = '';
      $_res = axios({
        method: 'POST',
        url: $_url,
        params: params,
        headers: {
          Authorization: `Bearer ${this.$store.getters.userAccToken}`,
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            return res;
          } else {
            return false;
          }
        })
        .catch(err => {
          return err;
        });

      return $_res;
    }
  },
  async axios(method, url, params) {
    let $_url = axios.defaults.baseURL + url;
    let $_res = '';
    if (method == 'GET') {
      $_res = axios.get($_url, { params: params }).then(res => {
        if (res.status === 200 || res.status === 204) {
          return res;
        } else {
          return false;
        }
      });
    } else if (method == 'POST') {
      $_res = axios({
        method: 'POST',
        url: $_url,
        params: params,
      })
        .then(res => {
          if (res.status === 200) {
            return res;
          } else {
            return false;
          }
        })
        .catch(err => {
          return err;
        });
    } else if (method == 'PUT') {
      $_res = axios({
        method: 'PUT',
        url: $_url,
        headers: {
          Authorization: `Bearer ${this.$store.getters.userAccToken}`,
          'Content-Type': 'multipart/form-data',
        },
        params: params,
      })
        .then(res => {
          if (res.status === 200) {
            return res;
          } else {
            return false;
          }
        })
        .catch(err => {
          return err;
        });
    } else if (method == 'DELETE') {
      $_res = axios({
        method: 'DELETE',
        url: $_url,
        headers: {
          Authorization: `Bearer ${this.$store.getters.userAccToken}`,
        },
      })
        .then(res => {
          if (res.status === 200) {
            return res;
          } else {
            return false;
          }
        })
        .catch(err => {
          return err;
        });
    } else if (method == 'FILE') {
      let path = axios.defaults.baseURL + 'uploader';
      var formdata = new FormData();
      formdata.append('files', url);
      $_res = axios({
        method: 'POST',
        url: path,
        formdata,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(res => {
          if (res.status === 200) {
            return res;
          } else {
            return false;
          }
        })
        .catch(err => {
          return err;
        });
    }
    return $_res;
  },
  async upLoad(method, path, files) {
    let url = axios.defaults.baseURL + path;

    if (method == 'post') {
      return axios
        .post(url, files, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.userAccToken}`,
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          if (res.status === 200) {
            return res;
          } else {
            return false;
          }
        })
        .catch(() => {
          return false;
        });
    } else if (method == 'put') {
      return axios
        .put(url, files, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${this.$store.getters.userAccToken}`,
          },
        })
        .then(res => {
          if (res.status === 200) {
            return res;
          } else {
            return false;
          }
        })
        .catch(() => {
          return false;
        });
    }
  },
  async get(url, param) {
    axios.get(url, param).then(res => {
      if (res.status === 200 || res.status === 204) {
        return res;
      } else {
        return false;
      }
    });
  },
  login(param) {
    let url = axios.defaults.admin + 'session';
    return new Promise(resolve => {
      axios({ method: 'POST', url: url, params: param })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          resolve(err);
        });
    });
  },
};

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['userAccToken']),
  },
  methods: {},
  install(Vue) {
    Vue.prototype.$_axios = methods.axios;
    Vue.prototype.$_admin_get = methods.admin_get;
    Vue.prototype.$_admin_post = methods.admin_post;
    Vue.prototype.$_upLoad = methods.upLoad;
    Vue.prototype.$_login = methods.login;
  },
};
